import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'usb-flights-filter',
  templateUrl: './flights-filter.component.html',
  styleUrls: ['./flights-filter.component.scss']
})
export class FlightsFilterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
